import { ProductQueryParam, SearchMaskGroupType, SearchMaskInputType, } from '../../../globalTypes';
import { settings } from '../../../settings';
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days';
var FlightRouter = /** @class */ (function () {
    function FlightRouter() {
    }
    FlightRouter.fillTravelPeriod = function (searchMaskGroup, params) {
        var searchMaskInput = searchMaskGroup.inputs[SearchMaskInputType.TRAVEL_PERIOD];
        if (searchMaskInput && searchMaskInput.coreQuery) {
            var departureDate = searchMaskInput.coreQuery[ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_DATE];
            if (departureDate) {
                params.append('departureDate', departureDate);
            }
            var returnDate = searchMaskInput.coreQuery[ProductQueryParam.TRAVEL_PERIOD_RETURN_DATE];
            if (returnDate) {
                params.append('returnDate', returnDate);
            }
            var duration = searchMaskInput.coreQuery[ProductQueryParam.TRAVEL_PERIOD_DURATION];
            if (duration) {
                var durationString = '' + duration;
                var durationMin = parseInt(durationString.substr(1, 2), 10);
                var durationMax = parseInt(durationString.substr(3, 2), 10);
                if (searchMaskInput.confirmedValue.value.exactDuration) {
                    params.append('exactDepartureDate', 'true');
                    params.append('exactReturnDate', 'true');
                    if (departureDate && returnDate) {
                        params.append('duration', '' + differenceInCalendarDays(returnDate, departureDate));
                    }
                }
                else if (durationMin === 0 && durationMax === 0) {
                    params.append('exactDepartureDate', 'false');
                    params.append('exactReturnDate', 'false');
                    params.append('duration', '-1');
                }
                else {
                    params.append('exactDepartureDate', 'false');
                    params.append('exactReturnDate', 'false');
                    params.append('duration', '' + durationMin + '-' + durationMax);
                }
            }
        }
    };
    FlightRouter.fillDepartureAirports = function (searchMaskGroup, params) {
        var searchMaskInput = searchMaskGroup.inputs[SearchMaskInputType.DEPARTURE_AIRPORT];
        FlightRouter.fillAirports(params, searchMaskInput, 'departureAirports');
    };
    FlightRouter.fillArrivalAirports = function (searchMaskGroup, params) {
        var searchMaskInput = searchMaskGroup.inputs[SearchMaskInputType.ARRIVAL_AIRPORT];
        FlightRouter.fillAirports(params, searchMaskInput, 'arrivalAirports');
    };
    FlightRouter.fillAirports = function (params, searchMaskInput, paramName) {
        if (searchMaskInput && searchMaskInput.confirmedValue && searchMaskInput.confirmedValue.value) {
            if (Array.isArray(searchMaskInput.confirmedValue.value) && searchMaskInput.confirmedValue.value.length > 0) {
                var airportCodes_1 = [];
                var values = searchMaskInput.confirmedValue.value;
                values.forEach(function (value) {
                    if (value.airports) {
                        // Airport group
                        value.airports.forEach(function (airports) {
                            if (Array.isArray(airports)) {
                                airports.forEach(function (airport) {
                                    airportCodes_1.push(airport.code);
                                });
                            }
                            else {
                                airportCodes_1.push(airports.code);
                            }
                        });
                    }
                    else {
                        // Airport
                        airportCodes_1.push(value.code);
                    }
                });
                //@ts-ignore
                var airportCodesParam = airportCodes_1.join(';');
                params.append(paramName, airportCodesParam);
            }
        }
    };
    FlightRouter.fillTravellers = function (searchMaskGroup, params) {
        var searchMaskInput = searchMaskGroup.inputs[SearchMaskInputType.TRAVELLERS];
        if (searchMaskInput && searchMaskInput.coreQuery) {
            var adults = searchMaskInput.coreQuery[ProductQueryParam.TRAVELLERS_ADULTS];
            if (adults) {
                params.append('travellers[adults]', '' + adults);
            }
            var children = searchMaskInput.coreQuery[ProductQueryParam.TRAVELLERS_CHILDREN_AGE];
            if (children && Array.isArray(children) && children.length > 0) {
                children.forEach(function (child) {
                    params.append('travellers[children][]', '' + child);
                });
            }
        }
    };
    FlightRouter.generate = function (lturState) {
        var result = '';
        if (lturState.websiteState &&
            lturState.websiteState.searchMask &&
            lturState.websiteState.searchMask.searchMaskBundle &&
            lturState.websiteState.searchMask.searchMaskBundle.groups
            && lturState.websiteState.searchMask.searchMaskBundle.groups[SearchMaskGroupType.FLIGHT]) {
            var baseUrl = settings.flightRouter.lturFlyBaseUrl;
            var url = new URL(baseUrl);
            var params = url.searchParams;
            params.append('bookingType', 'flight');
            params.append('external', 'true');
            var searchMaskGroup = lturState.websiteState.searchMask.searchMaskBundle.groups[SearchMaskGroupType.FLIGHT];
            FlightRouter.fillTravelPeriod(searchMaskGroup, params);
            FlightRouter.fillDepartureAirports(searchMaskGroup, params);
            FlightRouter.fillArrivalAirports(searchMaskGroup, params);
            FlightRouter.fillTravellers(searchMaskGroup, params);
            params.append('searchin', 'DE-SB-FL');
            result = url.href;
        }
        return result;
    };
    return FlightRouter;
}());
export { FlightRouter };
export default FlightRouter;
